let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6KVai")).then(() => parcelRequire('14g7o'));